<template>
  <div>
    <calendar v-if="$store.getters.getUserHasFeature('calendar')" />
    <div
      v-else
      class="wrapper pt-3 pb-1">
      <f-alert
        visible
        class="my-2"
        theme="inactive">
        <span>
        {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
        </span>
      </f-alert>
    </div>
  </div>
</template>

<script>
import Calendar from '@/views/Calendar.vue';

export default {
  name: 'calendar-wrapper',
  components: {
    'calendar': Calendar
  }
}
</script>
